/*
 * Copyright (c) 2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'

const entity = {
  name: {},
  description: {},
  fileFormat: {},
  type: {},
  level: {},
  storeName: {},
  area: {}
}
const config = {
  load: async function (filter) {
    return [{ name: '销售报告', description: '销售统计相关信息', fileFormat: 'excel', type: '日报', level: 1, storeName: '代理', area: '华中地区' },
      { name: '员工报告', description: '员工支出相关信息', fileFormat: 'excel', type: '日报', level: 1, storeName: '代理', area: '华中地区' }]
  }
}
export default IKDataEntity.ModelFactory(entity, config)
